<template>
  <div>
    <ele-pro-table
      ref="table"
      :datasource="url"
      :columns="columns"
      :where="where"
      height="calc(100vh - 261px)"
      tool-class="ele-toolbar-form">
      <template slot="toolbar">
        <el-form
          :model="where"
          class="ele-form-search"
          size="small"
          @keyup.enter.native="reload"
          @submit.native.prevent>
          <el-row :gutter="10">
            <el-col :md="8">
              <el-form-item>
                <el-input v-model="where.name" placeholder="字典项名称" clearable size="small" />
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item>
                <el-input v-model="where.code" placeholder="字典项值" clearable size="small" />
              </el-form-item>
            </el-col>
            <el-col :md="8">
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" size="small" @click="reload">查询</el-button>
                <el-button
                  v-if="permission.includes('sys:dictionary:add')"
                  type="primary"
                  icon="el-icon-plus"
                  class="ele-btn-icon"
                  size="small"
                  @click="openEdit(null)">添加
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
      <template slot="listClass" slot-scope="{ row }">
        <el-tag
          v-if="row.name"
          v-bind="tagProps(row.list_class)"
          size="mini">{{ row.name }}</el-tag>
      </template>
      <template slot="action" slot-scope="{ row }">
        <el-link
          v-if="permission.includes('sys:dictionary:edit')"
          type="primary"
          :underline="false"
          icon="el-icon-edit"
          @click="openEdit(row)">编辑
        </el-link>
        <el-popconfirm
          v-if="permission.includes('sys:dictionary:delete')"
          class="ele-action"
          title="确定要删除此字典项吗？"
          @confirm="remove(row)">
          <el-link slot="reference" type="danger" :underline="false" icon="el-icon-delete">删除</el-link>
        </el-popconfirm>
      </template>
    </ele-pro-table>
    <dict-data-edit :visible.sync="showEdit" :data="current" :dict-id="dictId" @done="reload" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { resolveDictTag } from '@/utils/dict';
import DictDataEdit from './dict-data-edit';

export default {
  name: 'DictData',
  components: { DictDataEdit },
  props: {
    dictId: Number
  },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/dictdata/index',
      columns: [
        { columnKey: 'index', type: 'index', label: '序号', width: 60, align: 'center', fixed: 'left' },
        { prop: 'name', label: '字典项名称', align: 'center', showOverflowTooltip: true, minWidth: 120 },
        { prop: 'code', label: '字典项值', align: 'center', showOverflowTooltip: true, minWidth: 100 },
        { prop: 'list_class', label: '样式', align: 'center', width: 120, slot: 'listClass' },
        { prop: 'sort', label: '排序', align: 'center', width: 80 },
        { prop: 'note', label: '备注', align: 'center', showOverflowTooltip: true, minWidth: 140 },
        {
          columnKey: 'action',
          label: '操作',
          width: 130,
          align: 'center',
          resizable: false,
          slot: 'action',
          fixed: 'right'
        }
      ],
      where: {
        dictId: this.dictId,
        name: '',
        code: ''
      },
      current: null,
      showEdit: false
    };
  },
  watch: {
    dictId(val) {
      this.where.dictId = val;
      this.reload();
    }
  },
  methods: {
    tagProps(listClass) {
      const tag = resolveDictTag(listClass);
      return {
        type: tag.type || undefined,
        style: tag.style
      };
    },
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http.post('/dictdata/delete', { id: row.id }).then((res) => {
        loading.close();
        if (res.data.code === 0) {
          this.$message.success(res.data.msg);
          this.reload();
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        loading.close();
        this.$message.error(e.message);
      });
    }
  }
};
</script>
